<template>
    <div>
        <div class="modal-dialog modal-xxl">
            <div class="modal-content">
                <div class="modal-header bg-primary p-5">
                    <h2 class="text-white"> {{ $t('person_details') }} </h2>
                    <div class="btn btn-sm btn-icon btn-active-color-primary" data-bs-dismiss="modal" ::aria-label="$t('close')" ref="closePersonModal" @click="onCloseModal()">
                        <span class="svg-icon svg-icon-1 text-white text-hover-dark">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none">
                                <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1"
                                    transform="rotate(-45 6 17.3137)" fill="currentColor"></rect>
                                <rect x="7.41422" y="6" width="16" height="2" rx="1"
                                    transform="rotate(45 7.41422 6)" fill="currentColor"></rect>
                            </svg>
                        </span>
                    </div>
                </div>
                <div class="modal-body pt-2"> 
                     <div class="card card-xxl-stretch pt-3">
                        <div class="card-body">
                            <div class="row">  
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <label class="col-lg-4 col-form-label form-label fw-bold p-2">
                                            {{ $t('date_of_birth') }}
                                        </label>
                                        <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                            <Datepicker :locale="$datepickerLocale()"  name="birth_date" :required="this.$checkIfDateFieldRequired ('birth_date')" textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="factorPersonForm.birth_date" format="dd.MM.yyyy" previewFormat="dd.MM.yyyy" autoApply :clearable="false" :enableTimePicker="false" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <label class="col-lg-4 col-form-label form-label fw-bold p-2">
                                            {{ $t('gender') }}
                                        </label>
                                        <div class="col-lg-8 fv-row fv-plugins-icon-container">                                                
                                            <Select2 v-model="factorPersonForm.gender" :options="genderList" name="gender" v-custom 
                                                :settings="{ width: '100%', dropdownParent: '#kt_modal_person .modal-content' }" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <label class="col-lg-4 col-form-label form-label fw-bold p-2">
                                            {{ $t('position_type') }}
                                        </label>
                                        <div class="col-lg-8 fv-row fv-plugins-icon-container">                                                
                                            <Select2 v-model="factorPersonForm.position_type_id" :options="personPositionList" name="position_type_id" v-custom 
                                                :settings="{ width: '100%', dropdownParent: '#kt_modal_person .modal-content' }" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <label class="col-lg-4 col-form-label form-label fw-bold p-2">
                                            {{ $t('position_date') }}
                                        </label>
                                        <div class="col-lg-8 fv-row fv-plugins-icon-container">                                               
                                            <Datepicker :locale="$datepickerLocale()"  name="position_date" :required="this.$checkIfDateFieldRequired ('position_date')" textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="factorPersonForm.position_date" format="dd.MM.yyyy" previewFormat="dd.MM.yyyy" autoApply :clearable="false" :enableTimePicker="false" />
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <label class="col-lg-4 col-form-label form-label fw-bold p-2">
                                            {{ $t('licence_number') }}
                                        </label>
                                        <div class="col-lg-8 fv-row fv-plugins-icon-container">
                                            <input type="text" class="form-control" name="licence_number" v-model="factorPersonForm.licence_number" v-custom>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-lg-6">
                                    <div class="row mb-2">
                                        <label class="col-lg-4 col-form-label form-label fw-bold p-2">
                                            {{ $t('licence_date') }}
                                        </label>
                                        <div class="col-lg-8 fv-row fv-plugins-icon-container">                                               
                                            <Datepicker :locale="$datepickerLocale()"  name="licence_date" :required="this.$checkIfDateFieldRequired ('licence_date')" textInput :textInputOptions="{ format: 'dd.MM.yyyy' }" v-maska="'##.##.####'" v-model="factorPersonForm.licence_date" format="dd.MM.yyyy" previewFormat="dd.MM.yyyy" autoApply :clearable="false" :enableTimePicker="false" />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card-footer">
                           <button class="btn btn-success btn-sm w-100" type="button" @click="this.onSavePerson()"> <i class="fa fa-save"></i>  {{ $t('save_person') }}  </button>
                        </div>
                     </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
export default {
    name:'FactorPersonModal',
    data(){
        return {
            factorPersonForm: {
                gender: '-1',
                birth_date: null,
                position_type_id: '-1',
                position_date: null,
                licence_number: null,
                licence_date: null,
            },
            genderList: [
                {id: '-1', text: this.$t('select_an_option')},
                {id: 'M', text: this.$t('male')},
                {id: 'F', text: this.$t('female')},
                {id: 'O', text: this.$t('other')},
            ],
            personPositionList: []
        }
    },
    methods:{
        getData(){
            this.clearForm();
            const parametersOne = {
                session_id : this.$getUser().session_id,
                list_types: [
                    { list_type: 19, list_name: "person_position" }
                ],
            };        
            const requestOne =  axios.post('/api/Helper/GetMultiPolicyLists', parametersOne, {'Content-Type': 'application/json'});        
            axios.all([requestOne]).then(axios.spread((...responses) => {            
                this.personPositionList = responses[0].data.person_position;            
                this.personPositionList.unshift({ id: '-1', text: this.$t('select_an_option')});
            }))
            .catch(errors => { 
                console.error(errors); 
            });
        },
        onSavePerson() {
            this.$refs.closePersonModal.click();
        },
        onCloseModal() {
            this.$parent.isViewFactorPersonModal = false;
        },
        clearForm() {
            this.factorPersonForm = {
                gender: '-1',
                birth_date: null,
                position_type_id: '-1',
                position_date: null,
                licence_number: null,
                licence_date: null,
            };
        }
    }
}
</script>